<!-- eslint-disable @angular-eslint/template/prefer-ngsrc -->
<div class="slideshow-content">
  <div class="image-container">
    <picture>
      <!-- TODO: This is the best solution but until angular ngOptimize does not implemente picture compatibilty  -->
      <source media="(max-width: 767px)" [srcset]="this.slide?.image?.mobileImage?.image + '?format=webp&width=767 767w'" />
      <source
        media="(min-width: 768px) and (max-width: 992px)"
        [srcset]="this.slide?.image?.tabletImage?.image + '?format=webp&width=992 992w'"
      />
      <source media="(min-width: 993px)" [srcset]="this.slide?.image?.desktopImage?.image + '?format=webp&width=1920 1920w'" />
      <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
      <img
        class="imageFit"
        fetchpriority="high"
        [src]="this.slide?.image?.desktopImage?.image + '?format=webp&width=1920 1920w'"
        [alt]="slide?.image?.altText ?? ''"
        [ngStyle]="{
          '--desktopimagefit': slide?.image?.desktopImage?.imageFit || defaultImageFit,
          '--tabletimagefit': slide?.image?.tabletImage?.imageFit || defaultImageFit,
          '--mobileimagefit': slide?.image?.mobileImage?.imageFit || defaultImageFit
        }"
      />
    </picture>
  </div>
  <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
  <div
    class="slideshow-caption"
    [ngStyle]="{
      '--slideshow-caption-background-color-desktop': slide?.text?.textbkgcolor?.desktop || 'transparent',
      '--slideshow-caption-background-color-tablet-mobile': slide?.text?.textbkgcolor?.tabletmobile || 'transparent'
    }"
  >
    <div class="caption-content">
      <div class="caption-content-top">
        @if (!slide?.text?.highlight?.hide) {
          <div class="caption-content-highlight" [innerHTML]="slide?.text?.highlight?.text"></div>
        }
        @if (!slide?.text?.title?.hide) {
          @if (slide?.text?.title?.title1) {
            <h2 class="caption-content-title-light" [innerHTML]="slide?.text?.title?.title1"></h2>
          }
          @if (slide?.text?.title?.title2) {
            <h2 class="caption-content-title-semi-bold" [innerHTML]="slide?.text?.title?.title2"></h2>
          }
        }
        @if (!slide?.text?.subtitle?.hide && slide?.text?.subtitle?.subtitle) {
          <h3
            class="caption-content-subtitle"
            [innerHTML]="slide?.text?.subtitle?.subtitle | cleanTags | sanitizeContent: 'html'"
          ></h3>
        }
        @if (!slide?.text?.description?.hide && slide?.text?.description?.description) {
          <div
            class="caption-content-description"
            [innerHTML]="slide?.text?.description?.description | sanitizeContent: 'html'"
          ></div>
        }
      </div>
      @if (!slide?.cta?.hide) {
        <div class="caption-content-ctas">
          @if (!slide?.cta?.cta?.hide) {
            <a
              class="btn caption-button"
              role="button"
              [ngClass]="captionButtonClass"
              [href]="slide?.cta?.cta?.link"
              [title]="slide?.cta?.cta?.altText"
              [attr.target]="slide?.cta?.cta?.newtab ? '_blank' : '_self'"
            >
              {{ slide?.cta?.cta?.text }}
            </a>
          }
          @if (!slide?.cta?.actionLink?.hide) {
            <a
              class="caption-link"
              [ngClass]="captionLinkClass"
              [href]="slide?.cta?.actionLink?.link"
              [title]="slide?.cta?.actionLink?.altText"
              [attr.target]="slide?.cta?.actionLink?.newtab ? '_blank' : '_self'"
            >
              {{ slide?.cta?.actionLink?.text }}
            </a>
          }
        </div>
      }
      @if (!slide?.text?.conditional?.hide && this.slide?.text?.conditional?.text) {
        <div class="caption-conditional" [innerHTML]="this.slide?.text?.conditional?.text | sanitizeContent: 'html'"></div>
      }
    </div>
  </div>
</div>
